export const path = '/glp-won-sms-consent';
export const component = 'GlpWonSmsConsent';
